import React from "react";
import * as yup from "yup";

import { Grid } from "@mui/material";
import { Input } from "Components/Form";
import { zonedTimeToUtc } from "date-fns-tz";
import { DespatchTask } from "Models/despatch.task";
import { Task, TaskStartDatePeriod } from "Models/task";
import { useTranslation } from "react-i18next";
import { UseState } from "Types";

import { ChangeTaskTimeSelectPeriod } from "./ChangeTaskTimeSelectPeriod";
import useYupValidation from "Hooks/useYupValidation";
import { useAppState } from "Context/StateContext";

interface ChangeTaskTimeDefaultPeriodFormProps {
  task: DespatchTask | Task;
  setTask: UseState<DespatchTask | Task | undefined>;
  isLoading: boolean;
  errors?: yup.ValidationError[];

  setWhatHasChanged?: (field: string) => void;
}
export const ChangeTaskTimeDefaultPeriodForm = ({
  task,
  isLoading,
  setTask,
  setWhatHasChanged,
  errors = [],
}: ChangeTaskTimeDefaultPeriodFormProps) => {
  const { t: translate } = useTranslation();
  const { fieldHasError, getErrorByField } = useYupValidation(errors);
  const { formatWithUserTimezone, userTimezone } = useAppState();

  return (
    <>
      <Grid item xs={12}>
        <ChangeTaskTimeSelectPeriod
          setTask={setTask}
          task={task}
          isLoading={isLoading}
          setWhatHasChanged={setWhatHasChanged}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Input
          type="time"
          label={translate("from")}
          disabled={isLoading || task.period !== TaskStartDatePeriod.CUSTOM}
          value={task.startDate ? formatWithUserTimezone(task.startDate, "HH:mm") : ""}
          onChange={(event) => {
            if (event?.target?.value && task) {
              const timeSplitted = event.target.value.split(":");

              if (timeSplitted && timeSplitted?.length > 0) {
                const oldDate = new Date(task.startDate);

                oldDate.setHours(Number(timeSplitted[0]), Number(timeSplitted[1]));

                const startDate = zonedTimeToUtc(oldDate, userTimezone.name).toISOString();

                if (startDate)
                  setTask((state) =>
                    state
                      ? {
                          ...state,
                          startDate,
                        }
                      : ({ startDate } as DespatchTask)
                  );

                setWhatHasChanged?.("startTime");
              }
            }
          }}
          error={fieldHasError("startTime")}
          errorMessage={getErrorByField("startTime")}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Input
          type="time"
          label={translate("to")}
          disabled={isLoading || task.period !== TaskStartDatePeriod.CUSTOM}
          value={task.endDate ? formatWithUserTimezone(task.endDate, "HH:mm") : ""}
          onChange={(event) => {
            if (event?.target?.value && task) {
              const timeSplitted = event.target.value.split(":");

              if (timeSplitted && timeSplitted?.length > 0) {
                const oldDate = new Date(task.startDate);

                oldDate.setHours(Number(timeSplitted[0]), Number(timeSplitted[1]));

                const endDate = zonedTimeToUtc(oldDate, userTimezone.name).toISOString();

                if (endDate)
                  setTask((state) =>
                    state
                      ? {
                          ...state,
                          endDate,
                        }
                      : ({ endDate } as DespatchTask)
                  );

                setWhatHasChanged?.("endTime");
              }
            }
          }}
          error={fieldHasError("endTime")}
          errorMessage={getErrorByField("endTime")}
        />
      </Grid>
    </>
  );
};
